import axios from 'axios'

const apiRest = axios.create({
  baseURL: process.env.REACT_APP_HOST_APY_REST,
  headers: { Accept: 'application/json' },
})

apiRest.interceptors.request.use((req) => {
  const { token } = sessionStorage
  req.headers.Authorization = token && `Bearer ${token}`
  return req
})

apiRest.interceptors.response.use(
  (res) => res,
  (error) => {
    // Se for falta de internet atualize a página
    // TO DO: Deve funcionar offline e informar na UI sobre a falta de conexão
    if (!error.response) {
      window.location.reload()
      return
    }
    // Token inválido
    if (error.response.status === 403) {
      sessionStorage.removeItem('token')
      window.location.reload()
    }
    return Promise.reject(error.response)
  }
)

export default apiRest
